import { render, staticRenderFns } from "./regTypeList.vue?vue&type=template&id=d89a7b16"
import script from "./regTypeList.vue?vue&type=script&lang=js"
export * from "./regTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports